import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Box, Typography, Stack } from "@mui/material"

import { Videos, ChannelCard } from "./"
import { fetchFromAPI } from '../utils/fetchFromAPI'

export default function ChannelDetail() {

    const { id } = useParams()

    const [channelDetail, setChannelDetail] = useState(null)
    const [videos, setVideos] = useState([])

    useEffect(() => {
        fetchFromAPI(`channels?part="snippet&id=${id}`)
            .then((data) => setChannelDetail(data?.items[0]))

        fetchFromAPI(`search?channelId=${id}&part=snippet&order=date`)
            .then((data) => setVideos(data?.items))
    }, [id])

    console.log(channelDetail)

    return (
        <Box
            minHeight={"95vh"}
        >
            <Box>
                <div
                    style={{
                        background: "linear-gradient(90deg, rgba(180,160,58,1) 0%, rgba(253,29,29,1) 50%, rgba(252,176,69,1) 100%)",
                        zIndex: 10,
                        height: "200px"
                    }}
                />
                <Stack
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "10px"
                    }}
                >
                    <ChannelCard
                        channelDetail={channelDetail}
                        marginTop={"-110px"}
                        statistics={parseInt(channelDetail?.statistics?.subscriberCount)}
                    />
                    <Typography
                        sx={{
                            fontSize: 14,
                            textAlign: "center",
                            color: "#fff",
                            width: "70%",
                            mb: "5px"
                        }}
                    >
                        {channelDetail?.snippet?.description}
                    </Typography>
                </Stack>
            </Box>
            <Box
                display={"flex"}
                p={2}
            >
                <Box
                    sx={{
                        mr: { sm: "100px" }
                    }}
                >
                    <Videos videos={videos} flexPosition={true} />
                </Box>
            </Box>
        </Box>
    )
}
